/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 14:44:15
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 14:04:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/ListPage/index.tsx
 */
import { LineCollapse } from '@/src/components';
//import { groupSortingByTime } from 'src/tools/helper';
import Warning from '@/src/components/Antd/Modal/WarningModal';
import { Icon } from '@/src/tools/icon';
import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { AddIconButton } from 'src/components/Buttons';
import _SeparatedContentCard from 'src/components/Card/SeparatedContentCard';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { formatDateFromServer } from 'src/constrains/TimeAndDatePickField';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  deleteContentContentPage,
  duplicateContentContentPage,
  getContentContentPages,
} from 'src/request/salesChannel/content';
import { NULL } from 'src/tools/constant';
import { msg } from 'src/tools/message';
import { i18nGet, handleOnFormatCurrentSCTimeAndDate } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import css from './css.module.less';

// const formatMoment = (time) => {
//   return moment(time).format('DD MMM YY HH:mm');
// };
const _format = (_s, _e) => {
  return `${handleOnFormatCurrentSCTimeAndDate(
    _s,
  )} - ${handleOnFormatCurrentSCTimeAndDate(_e)}`;
};

const SeparatedContentCard = (props) => {
  return (
    <div className={css.cardContainer}>
      <_SeparatedContentCard {...props} />
    </div>
  );
};

const ListPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [group, setGroup] = useState(['InUse', 'Pending', 'Previous']);

  const [deleteWarningVisible, setDeleteWarningVisible] = React.useState(false);
  const [selectedUuid, setSelectedUuid] = React.useState(null);
  //const [data,setData]=useState()
  const [statics, setStatics] = React.useState({
    timezoneInGmt: undefined,
    salesChannelName: '',
    salesChannelContent: {},
  });
  const [inUseGroup, setInUseGroup] = React.useState([]);
  const [inPendingGroup, setPendingGroup] = React.useState([]);
  const [inPreviousGroup, setPreviousGroup] = React.useState([]);
  const _h = useHistory();
  const _params: { saleChannelUuid: string; contentUuid: string } = useParams();
  const { saleChannelUuid, contentUuid } = _params;
  const { timezoneInGmt, salesChannelName, salesChannelContent } = statics;
  const _s: any = salesChannelContent || {};
  const { versionName, status } = _s;
  const _jumpTo = (uuid: string, disable?) => {
    _h.push(
      `/salesChannel/editor/content/contentPage/${saleChannelUuid}/${contentUuid}/${uuid}${
        disable ? '?disable=true' : ''
      }`,
    );
  };
  const goBack = () => {
    _h.push(`/salesChannel/content/${saleChannelUuid}`);
  };
  // const multiProps = props[SALES_CHANNELS_MULTI_LANG_PROPS];
  // useGetPageLanguageList(multiProps);
  const currentLanguage = useQueryLanguageListContentEditor();
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());

  React.useEffect(() => {
    getContentContentPages(contentUuid, {
      salesChannelMultiLanguageRequired: true,
    }).then((res) => {
      const {
        inUsePages,
        pendingPages,
        previousPages,
        salesChannelName,
        timezoneInGmt,
        salesChannelContent,
      } = res;
      setStatics({ salesChannelName, timezoneInGmt, salesChannelContent });
      setInUseGroup(inUsePages);
      setPendingGroup(pendingPages);
      setPreviousGroup(previousPages);
    });
  }, [currentLanguage]);
  const handleOpenGroup = (keys: Array<string>) => {
    setGroup(keys);
    // if (keys.length == 0) {
    //   setGroup(['InUse']);
    // } else {
    //   setGroup(keys);
    // }
  };
  const options = (uuid) => [
    {
      onClick: () => {
        duplicateContentContentPage(uuid, {
          [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
        }).then((i) => {
          const { uuid } = i;
          _jumpTo(uuid);
        });
      },
      key: '1',
      body: getI18n('general.duplicate'),
    },
    {
      key: '2',
      body: getI18n('general.delete'),
      onClick: () => {
        setSelectedUuid(uuid);
        setDeleteWarningVisible(true);
      },
      isDangerous: true,
    },
  ];

  // const { inUse, pending, previous } = groupSortingByTime(_data);

  const cardGenerator = (i, index, obj?) => {
    const {
      name: content,
      hasError,
      uuid,
      alwaysOn,
      beginDate,
      beginTime,
      endDate,
      endTime,
    } = i;
    const titleProps: {
      title: string;
      err?: boolean;
      titleColor?: string;
    } = { title: '', ...(obj || {}) };
    const { disable } = obj || {};
    titleProps.err = hasError;

    if (alwaysOn) {
      titleProps.title = getI18n('salesChannelContent.index.alwayson');
    } else {
      if (beginDate && beginTime && endDate && endTime) {
        const _startTime = formatDateFromServer(beginDate, beginTime);
        const _endTime = formatDateFromServer(endDate, endTime);
        titleProps.title = _format(_startTime, _endTime);
      } else {
        titleProps.title = getI18n('general.moduleListError.999977');
        titleProps.titleColor = '#ff695f';
      }
    }

    return (
      <SeparatedContentCard
        {...(isOnPrimaryLanguage ? { dotsFunctions: options(uuid) } : {})}
        // dotsFunctions={options(uuid)}
        {...titleProps}
        content={content}
        key={index}
        onClick={(e, disable) => _jumpTo(uuid, disable)}
        disable={disable}
      />
    );
  };

  const data = [
    {
      headerText: getI18n('general.status.active'),
      key: 'InUse',
      content: (
        <React.Fragment>
          {inUseGroup.map((i, index) => {
            return cardGenerator(i, index);
          })}
        </React.Fragment>
      ),
    },
    {
      headerText: getI18n('general.paymentStatus.pending'),
      key: 'Pending',
      content: (
        <React.Fragment>
          {inPendingGroup.map((i, index) => {
            return cardGenerator(i, index);
          })}
        </React.Fragment>
      ),
    },
    {
      headerText: getI18n('salesChannelContent.index.previous'),
      key: 'Previous',
      content: (
        <React.Fragment>
          {inPreviousGroup.map((i, index) => {
            return cardGenerator(i, index, { disable: true });
          })}
        </React.Fragment>
      ),
    },
  ];

  const modalOnClose = () => {
    setSelectedUuid(null);
    setDeleteWarningVisible(false);
  };
  const handleOnDelete = () => {
    deleteContentContentPage(selectedUuid).then((i) => {
      msg.success('deleted');
      const { uuid } = i;
      if (
        inUseGroup.find((item) => {
          return item.uuid === uuid;
        })
      ) {
        const _inUseGroup = _.cloneDeep(inUseGroup || []);
        _.remove(_inUseGroup, (item) => {
          return item.uuid === uuid;
        });
        setInUseGroup(_inUseGroup);
      }

      if (
        inPendingGroup.find((item) => {
          return item.uuid === uuid;
        })
      ) {
        const _inPendingGroup = _.cloneDeep(inPendingGroup || []);
        _.remove(_inPendingGroup, (item) => {
          return item.uuid === uuid;
        });

        setPendingGroup(_inPendingGroup);
      }
      if (
        inPreviousGroup.find((item) => {
          return item.uuid === uuid;
        })
      ) {
        const _inPreviousGroup = _.cloneDeep(inPreviousGroup || []);
        _.remove(_inPreviousGroup, (item) => {
          return item.uuid === uuid;
        });
        setPreviousGroup(_inPreviousGroup);
      }
    });
    modalOnClose();
  };
  return (
    <React.Fragment>
      {deleteWarningVisible && (
        <Warning
          visible
          header={getI18n('salesChannelContent.index.deletecontentpage')}
          onOk={handleOnDelete}
          okText={getI18n('general.delete')}
          cancelText={getI18n('general.cancel')}
          onCancel={modalOnClose}>
          {getI18n('salesChannelContent.index.deletecontentpagetip')}
        </Warning>
      )}
      <PageWrapper
        //hideLeft
        headerConfig={{
          description: versionName,
          status: status,
          topTitle: salesChannelName,
          onGoBack: goBack,
        }}
        leftChild={
          <RightConfigWrapper
            title={getI18n('general.content.contentPages')}
            subtitle={`${getI18n('general.timeZone')} (UTC ${
              timezoneInGmt || ''
            })`}
            elements={[
              {
                body: (
                  <React.Fragment>
                    <div className={css.container}>
                      {isOnPrimaryLanguage ? (
                        <AddIconButton
                          style={{ width: 360 }}
                          onClick={_jumpTo.bind(this, NULL, false)}
                          text={getI18n(
                            'salesChannelContent.index.newContentPage',
                          )}
                        />
                      ) : (
                        <div>
                          <Icon type='iconinfo2' className={css.icon} />
                          {getI18n(
                            'salesChannelContent.index.addnewpageunderprimarylanguage',
                          )}
                        </div>
                      )}
                    </div>
                    <LineCollapse
                      open={group}
                      setOpen={handleOpenGroup}
                      data={data}
                    />
                  </React.Fragment>
                ),
                key: 'ContentPageList',
              },
            ]}
          />
        }
        // rightChild={

        // }
      />
    </React.Fragment>
  );
};
export default ListPage;
